import { getMargin as i } from "../../../../../../seemly@0.3.10/node_modules/seemly/es/css/index.js";
function f(t) {
  const {
    left: o,
    right: r,
    top: n,
    bottom: e
  } = i(t);
  return `${n} ${o} ${e} ${r}`;
}
export {
  f as rtlInset
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/_utils/css/rtl-inset.js
// module id = 1624
// module chunks = 67